if (!customElements.get("low-power-video")) {
  customElements.define(
    "low-power-video",
    class LowPowerVideo extends HTMLElement {
      constructor() {
        super();
      }

      connectedCallback() {
        this.video_section = this.querySelector(".wt-video");
        this.video_background_section = this.querySelector(
          ".hero--video-background",
        );
        this.external_video_container = this.querySelector(".video-cover__container");
        if (this.video_section) {
          if (this.external_video_container) {
            this.setupExternalVideo(this.external_video_container);
          } else {
            this.checkAndPlayVideoSection(this.video_section);
          }
        } else if (this.video_background_section) {
          this.checkAndPlayBackgroundVideoSection(
            this.video_background_section,
          );
        }
      }

      checkAndPlayBackgroundVideoSection(video_background_section) {
        const hero_overlay =
          video_background_section.querySelector(".hero__overlay");
        const video_element = video_background_section.querySelector("video");
        if (video_element) {
          hero_overlay.addEventListener("touchstart", () =>
            this.playVideo(video_element),
          );
          hero_overlay.addEventListener("click", () =>
            this.playVideo(video_element),
          );
        }
      }

      checkAndPlayVideoSection(video) {
        const video_element = video.querySelector("video");
        if (video_element) {
          video.addEventListener("touchstart", () =>
            this.playVideo(video_element),
          );
          video.addEventListener("click", () => this.playVideo(video_element));
        }
      }

      playVideo(video_element) {
        if (!video_element.playing) {
          video_element.play();
        }
      }

      setupExternalVideo(container) {
        const overlay = container.querySelector(".video-cover__overlay");
        const iframe = container.querySelector("iframe");
        
        if (overlay && iframe) {
          // Set up click events for the overlay
          overlay.addEventListener("touchstart", (e) => {
            e.preventDefault();
            this.playExternalVideo(iframe, overlay);
          });
          
          overlay.addEventListener("click", () => {
            this.playExternalVideo(iframe, overlay);
          });
        }
      }
      
      playExternalVideo(iframe, overlay) {
        overlay.classList.add('fade-out');
        let src = iframe.src;
        if (src.indexOf("autoplay=1") === -1) {
          if (src.indexOf("?") > -1) {
            if (src.charAt(src.length - 1) === '&') {
              iframe.src = src + "autoplay=1";
            } else {
              iframe.src = src + "&autoplay=1";
            }
          } else {
            iframe.src = src + "?autoplay=1";
          }
        }
      }

      disconnectedCallback() {
        if (this.video_section) {
          this.video_section.removeEventListener("touchstart", this.playVideo);
          this.video_section.removeEventListener("click", this.playVideo);
        }
        if (this.video_background_section) {
          const hero_overlay =
            this.video_background_section.querySelector(".hero__overlay");
          const video_element =
            this.video_background_section.querySelector("video");
          if (video_element) {
            hero_overlay.removeEventListener("touchstart", () =>
              this.playVideo(video_element),
            );
            hero_overlay.removeEventListener("click", () =>
              this.playVideo(video_element),
            );
          }
        }

        if (this.external_video_container) {
          const overlay = this.external_video_container.querySelector(".video-cover__overlay");
          const iframe = this.external_video_container.querySelector("iframe");
          if (overlay && iframe) {
            overlay.removeEventListener("touchstart", () => 
              this.playExternalVideo(iframe, overlay)
            );
            overlay.removeEventListener("click", () => 
              this.playExternalVideo(iframe, overlay)
            );
          }
        }
      }
    },
  );
}
